import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { E as ErrorState } from './utils.js';

const Details = /*@__PURE__*/ proxyCustomElement(class Details extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
    }
    render() {
        return (h(Host, { key: 'd00d3b1c3b5d73af5a0eb1a18f2095f023aeb816' }, this.errorMessage ?
            ErrorState(this.errorMessage)
            :
                h("main", { class: "p-2" }, h("slot", { name: "head-info" }), h("slot", { name: 'detail-sections' }))));
    }
}, [4, "justifi-details", {
        "errorMessage": [1, "error-message"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["justifi-details"];
    components.forEach(tagName => { switch (tagName) {
        case "justifi-details":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, Details);
            }
            break;
    } });
}
defineCustomElement();

export { Details as D, defineCustomElement as d };
